<template>
  <div>
    <swiper :active-item-index="activeContractIndex" @change="onChangeContract" v-if="ShowBills">
      <swiper-item v-for="contractId of contractIds" :key="contractId">
        <deposit-balance mobile :contract="contractId"></deposit-balance>
      </swiper-item>
    </swiper>

    <dashboard-actions class="mb-2"></dashboard-actions>
<!--    <pending-orders class="mb-2"></pending-orders>-->
    <stat-summary></stat-summary>
  </div>
</template>

<script>
import DepositBalance from './DepositBalance'
import DashboardActions from './DashboardActions'
// import PendingOrders from './PendingOrders'
import StatSummary from './StatSummary'
import { Swiper, SwiperItem } from '@/ui/slots/Swiper'

import contractIds from '@/mixins/contractIds'
import currContractId from '@/mixins/currContractId'
import { ShowBills } from '@/mixins/displayRules'

export default {
  mixins: [contractIds, currContractId, ShowBills],

  components: {
    Swiper,
    SwiperItem,

    DepositBalance,
    DashboardActions,
    // PendingOrders,
    StatSummary
  },

  computed: {
    activeContractIndex () {
      return this.contractIds.indexOf(+this.currContractId)
    }
  },

  methods: {
    onChangeContract (index) {
      this.setContract(this.contractIds[index])
    }
  }
}
</script>

<style lang="scss">
.swiper__item {
  min-height: 100px;
  background-color: $color-black-light;
  width: 80%;
}
</style>
